import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import { SPACE_RECORDS_SELECTION_TARGET } from '../../../constants'
import type { Plugin } from '../plugin'

/**
 * Releases records-list selected records after assignment completes or context changes.
 */
export const releaseRecordSelection = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    rxjs
      .merge(
        feature.actions.initiate.cancellation.observe(),
        feature.actions.submit.success.observe(),
        plugin.collection.feature.actions.changeContext.observe(),
      )
      .pipe(
        rxjs.map(action =>
          plugin.collection.plugins.selectionPlugin.applied.actions.putInSelectionLookup
            .from(action)
            .create({
              key: SPACE_RECORDS_SELECTION_TARGET,
              value: { release: true },
            }),
        ),
      ),
)
